// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title_2[data-v-b3a93d62] {\n  font-size: 16px;\n  height: 20px;\n  line-height: 20px;\n  font-weight: 600;\n  margin-top: 30px;\n  margin-bottom: 18px;\n}\n.edit-table[data-v-b3a93d62] {\n  margin-left: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
